import { FC } from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { getNf } from '../nfTokens'

export interface NfSectionHeadingProps {
  children: string
}

export const NfSectionHeading: FC<NfSectionHeadingProps> = ({ children }) => (
  <Stack direction="row" alignItems="center" spacing={1.25} sx={{ width: '100%' }}>
    <Typography
      component="span"
      sx={(theme) => ({
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: getNf(theme).muted,
        flexShrink: 0,
      })}
    >
      {children}
    </Typography>
    <Box
      sx={(theme) => ({
        flex: 1,
        height: '1px',
        bgcolor: getNf(theme).line2,
      })}
    />
  </Stack>
)

export default NfSectionHeading
